// Element Plus reverses this ascending comparator for descending sorts.
export function compareSummaryNumbers(a, b) {
  const missingA = a === null || a === undefined || a === '';
  const missingB = b === null || b === undefined || b === '';

  if (missingA || missingB) {
    if (missingA && missingB) return 0;
    return missingA ? -1 : 1;
  }

  const valueA = Number(a);
  const valueB = Number(b);
  if (valueA === valueB) return 0;
  return valueA < valueB ? -1 : 1;
}
